import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Select from 'flarum/common/components/Select';
import Icon from 'flarum/common/components/Icon';
import Stream from 'flarum/common/utils/Stream';
import { field, visPicker, section } from './Field';
import { TYPES_RU, TYPES_OTHER, VISIBILITY, MAX_LENGTH, typesFor, defaultVisibility, normalize } from '../utils/contactRules';
const t = (key, params) => app.translator.trans('ppk2-profile.forum.contacts.' + key, params);
const lib = (key, params) => app.translator.trans('ppk2-profile.lib.contact.' + key, params);
const ALL_TYPES = [...new Set([...TYPES_RU, ...TYPES_OTHER])];

/** Icon inside the input. MAX has no Font Awesome icon: a neutral «MAX» badge. */
const ICONS = {
  telegram: 'fab fa-telegram',
  vk: 'fab fa-vk',
  ok: 'fab fa-odnoklassniki',
  discord: 'fab fa-discord',
  facebook: 'fab fa-facebook',
  whatsapp: 'fab fa-whatsapp'
};
export function contactsState(user) {
  const stored = user.attribute('ppk2Contacts') || {};
  const initial = {
    contacts: {}
  };
  const s = {
    initial,
    values: {},
    vis: {},
    showErrors: false
  };
  ALL_TYPES.forEach(type => {
    const c = stored[type] || {};
    initial.contacts[type] = {
      value: c.value || '',
      visibility: c.visibility || defaultVisibility(type)
    };
    s.values[type] = Stream(initial.contacts[type].value);
    s.vis[type] = Stream(initial.contacts[type].visibility);
  });
  return s;
}

/** {ppk2Contacts?} with changed entries only (the notification table is in NotificationsTab). Hidden types are never touched. */
export function contactsPayload(s) {
  const data = {};
  const contacts = {};
  ALL_TYPES.forEach(type => {
    const init = s.initial.contacts[type];
    const raw = s.values[type]().trim();
    const entry = {};
    if (raw !== init.value) entry.value = raw ? normalize(type, raw)[0] || raw : null;
    if (s.vis[type]() !== init.visibility) entry.visibility = s.vis[type]();
    if (entry.value === init.value) delete entry.value;
    if (Object.keys(entry).length) contacts[type] = entry;
  });
  if (Object.keys(contacts).length) data.ppk2Contacts = contacts;
  return data;
}

/** [type, message] of the first invalid visible contact, or null. */
export function contactsLocalError(s, country) {
  for (const type of typesFor(country)) {
    const raw = s.values[type]().trim();
    if (!raw || raw === s.initial.contacts[type].value) continue;
    const [, error] = normalize(type, raw);
    if (error) return [type, lib(error, {
      max: MAX_LENGTH
    })];
  }
  return null;
}
function visibility(s, type, loading) {
  const options = {};
  VISIBILITY.forEach(v => options[v] = t('visibility.' + v));
  return visPicker('ppk2ContactVis-' + type, options, s.vis[type](), v => s.vis[type](v), loading, t('visibility.title'));
}

/**
 * Section «Контакты» at the bottom of tab «Инфо»: social networks / messengers (set depends
 * on the Info country), each with its own «Кто видит». Attrs: state (contactsState), country (current Info value), loading.
 */
export default class ContactsTab extends Component {
  view() {
    const s = this.attrs.state;
    const loading = this.attrs.loading;
    const rows = [section(t('section_contacts'))];
    typesFor(this.attrs.country).forEach(type => {
      const raw = s.values[type]();
      const changed = raw.trim() !== s.initial.contacts[type].value;
      const [clean, error] = raw.trim() ? normalize(type, raw) : [null, null];
      rows.push(field('contact-' + type, t('types.' + type), [m("div", {
        className: 'Ppk2ContactInput Ppk2ContactInput--' + type + (changed && error ? ' Ppk2ContactInput--invalid' : '')
      }, type === 'max' ? m("span", {
        className: "Ppk2MaxBadge"
      }, "MAX") : m(Icon, {
        name: ICONS[type],
        className: "Ppk2ContactInput-icon"
      }), m("input", {
        className: "FormControl",
        name: 'ppk2Contact-' + type,
        maxlength: MAX_LENGTH,
        autocomplete: "off",
        spellcheck: "false",
        placeholder: t('placeholders.' + type),
        value: raw,
        disabled: loading,
        oninput: e => s.values[type](e.target.value),
        onblur: () => {
          // show the cleaned form (e.g. t.me/name -> @name) once the field is left
          if (clean && clean !== raw) s.values[type](clean);
        }
      })), changed && error ? m("div", {
        className: "Ppk2NickStatus Ppk2NickStatus--invalid"
      }, m(Icon, {
        name: "fas fa-circle-xmark"
      }), " ", lib(error, {
        max: MAX_LENGTH
      })) : null], visibility(s, type, loading), t('tips.' + type)));
    });
    return m("div", {
      className: "Ppk2ContactsTab"
    }, rows);
  }
}
flarum.reg.add('ppk2-profile', 'forum/components/ContactsTab', ContactsTab);